import css from 'styled-jsx/css';

const styles = css.global`#banco-do-auto-carro .container-carro{
    display: flex;
    flex-direction: column;
}  

#banco-do-auto-carro .carro-title {
    color: #444;
    font-family: "SantanderHeadline";
    font-size: 32px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px;
    margin: 0;
}

#banco-do-auto-carro .carro-title b {
    color: #C00;
    font-weight: 800;
}

#banco-do-auto-carro .carro-paragrafo {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 32px;
    margin-top: 10px;
    max-width: 630px;
}

#banco-do-auto-carro .carro-paragrafo b {
    font-weight: 600;
}

#banco-do-auto-carro .btn-banco-do-auto-carro {
    width: 100%;
    height: 48px;
    margin-bottom: 48px;
}

#banco-do-auto-carro .banco-do-auto-imagem {
    width: 100%;
    max-width: 350px;
    margin-top: 48px;
    margin-bottom: 16px;
}

#banco-do-auto-carro .container-carro {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

#banco-do-auto-carro .carro-negrito {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
    margin: 16px 0 6px;
    display: block;
}

/* #banco-do-auto-carro.mobile .embla__slide {
    display: flex;
    align-items: flex-start;
}*/

#banco-do-auto-carro.mobile .embla__slide div{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    overflow: hidden;
} 

.banco-do-auto-btn-saiba-mais {
    width: 100%;
    height: 48px;
    margin-bottom: 48px;
    max-width: 280px;
}
#banco-do-auto-carro .link-banco-do-auto-carro {
    color: #C00;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    text-decoration: underline;
    margin-bottom: 48px;
}
#banco-do-auto-carro.mobile .home-pagination {
    margin-bottom: 20px;
    width: 100%;
}

@media(min-width: 992px) {
    .mobile {
        display: none!important;
    }

    #banco-do-auto-carro .carro-title {
        max-width: unset;
        font-size: 34px;
    }

    #banco-do-auto-carro {
        height: 409px;
        display: flex;
    }    

    #banco-do-auto-carro .container-carro {
        flex-direction: row;
    }
}`;

export default styles;